import React from "react"; 

// core components
import GridItem from "../../views/Grid/GridItem.js";
import GridContainer from "../../views/Grid/GridContainer.js";
import Table from "../../views/Table/Table.js";
import Card from "../../views/Card/Card.js";
import CardHeader from "../../views/Card/CardHeader.js";
import CardBody from "../../views/Card/CardBody.js";

import axios from 'axios'
import style from './styles.module.css'
import Button from '@material-ui/core/Button'
import ConfCategory from './confCategory/ConfCategory'
import IconButton from '@material-ui/core/IconButton'
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import Snackbar from '../utils/snackbar/Snackbar'
import {withRouter} from 'react-router-dom' 
import CircularProgress from '@material-ui/core/CircularProgress'
import TopBar from "../utils/Topbar/TopBar.js";
import {connect} from 'react-redux'
import {getCategory} from '../../containers/app/actions'
import SplitButton from "../utils/SplitButton/SplitButton.js";
import ConfirmAlert from "../utils/ConfirmAlert/ConfirmAlert.js";


const Category = (props) => { 
  const [filteredData,setFilteredData] = React.useState(false)
  const [searchValue,setSearchValue] = React.useState("")

  const [alert,setAlert] = React.useState(false);
  const [addModal,setAddModal] = React.useState(false);
  const [editModal,setEditModal] = React.useState(false);
  const [activeCategory,setCategory] = React.useState(false) 

  React.useEffect(() => {
    props.getCategory(props.user._id)
  },[]);
 

  React.useEffect(() => {
    if(props.category) {
      let arr = [];
      arr = props.category.filter(val => {
        if(val.categoryName.toLowerCase().includes(searchValue.toLowerCase()) || val.status.toLowerCase().includes(searchValue.toLowerCase())) {
          return val;
        }
      }) 
      setFilteredData(arr);
    } else {
      setFilteredData(false);
    }
  },[searchValue,props.category]);


  const handleDelete = (value) => {
    axios({
      method: "post",
      url: "/deleteCategory",
      data: {
        categoryId: value._id,
      }
    }).then(res => {
      setAlert("Deleted Successfully")
      props.getCategory(props.user._id);
    }).catch(err => {
      setAlert("Something went wrong");
    })
  }

  const isLoading = !filteredData;
  const showData = !isLoading;
  const details = [];

  
  !isLoading && filteredData.forEach((val,index) => {
    details.push(
      [
        index + 1,
        val.categoryName,
        val.categories_barcode,
        val.status, 
        <React.Fragment>  
          <IconButton onClick={() => {
            setCategory(val)
            setEditModal(true)
          }}>
            <EditRoundedIcon />
          </IconButton>
          <ConfirmAlert msg={`Are you sure you want delete ?`} onClickEvent={() => handleDelete(val)}>
            <IconButton>
              <DeleteRoundedIcon />
            </IconButton>
          </ConfirmAlert>
        </React.Fragment>
      ]
    )
  });


  return (
    <GridContainer>
      
      {addModal && <ConfCategory
        type="ADD" 
        open={addModal} 
        onClose={() => setAddModal(false)} 
        onDone={() => {
          setAddModal(false)
          props.getCategory(props.user._id)
        }}
        setAlert={(msg) => setAlert(msg)}
      />}
      {activeCategory && <ConfCategory 
        type="EDIT"
        category={activeCategory} 
        open={editModal} 
        onClose={() => {
          setEditModal(false)
          setCategory(false)
        }} 
        onDone={() => {
          setEditModal(false)
          setCategory(false)
          props.getCategory(props.user._id)
        }} 
        setAlert={(msg) => setAlert(msg)}
      />} 
 
      <Snackbar open={alert} handleClose={() => setAlert(false)}/>
 
      <TopBar 
        searchValue={searchValue} 
        onSearchChange={(value) => setSearchValue(value)}  


        nav={[
          {Name: "Products",onClick: () => props.history.push("/admin/product")},
          {Name: "Category",onClick: () => {}}
        ]}
      />

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div className={style.cardHeader}>
              <h4>All Category</h4> 

              <div className={style.buttons}>
                {/* <SplitButton
                  options={
                    [ {name: "Category",onClick: () => props.history.push("/admin/categories")},
                      {name: "Parts",onClick: () => props.history.push("/admin/parts")},
                      {name: "Series",onClick: () => props.history.push("/admin/series")},
                    ]
                  }
                  name={"Explore"}
                  color="secondary"
                /> */}

                <Button color="secondary" variant="contained" onClick={() => setAddModal(true)}>Add Category</Button> 
              </div>
            </div>
          </CardHeader>
          <CardBody>
            {isLoading &&
              <div className={style.loader}>
                <CircularProgress />
              </div>
            }
            
            {showData && 
              <Table
                tableHeaderColor="primary"
                tableHead={["Sl No", "Category Name", "Barcode", "Status","Action"]}
                tableData={details}
              />}
          </CardBody>
        </Card>
      </GridItem> 
    </GridContainer>
  );
}

const mapStateToProps = state => ({
  user: state.appReducer.user,
  category: state.appReducer.category,
  showAddCategory: state.appReducer.showAddCategory
})
export default withRouter(connect(mapStateToProps, {getCategory})(Category));